import React from "react";
import Marquee from "react-fast-marquee";

// interfaces
import { IInfiniteMarquee } from "./IInfiniteMarquee";

// assets
import styles from "@/assets/styles/components/infinite-marquee.module.scss";

function InfiniteMarquee({ items, className = "" }: IInfiniteMarquee) {

  return (
    <Marquee
      className={`${styles["locl-infinite-marquee"]} ${className}`}
      autoFill
      pauseOnHover
    >
      {items.map((item, index) => (
        <div key={index} className={styles["locl-infinite-marquee__item"]} data-testid="locl-infinite-marquee-item">
          {item}
        </div>
      ))}
    </Marquee>
  );
}

export default InfiniteMarquee;
